import TnCompetitiveAnalysis from './view';

const TnCompetitiveAnalysisPage = {
    name: 'TnCompetitiveAnalysis',
    list: TnCompetitiveAnalysis
};

export default TnCompetitiveAnalysisPage;